<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Tendering Proces - Step 4 of 4 (Best Supplier/vendor Selection)
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="backStep()"><i class="fa fa-backward"></i> Prev.Step</button>
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
          <button class="btn btn-primary mr-1" @click="printBestSupplier()"><i class="fa fa-print"></i> Best Supplier</button>
          <button class="btn btn-danger mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="8">
          <b-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend><label>Tendering Number</label></b-input-group-prepend>
                <b-form-input v-model="model.nomor" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend><label>Tendering Date</label></b-input-group-prepend>
                <b-form-input v-model="model.tanggal" type="date" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend><label>Note/Description</label></b-input-group-prepend>
            <b-form-input v-model="model.uraian" placeholder="Note/Description" disabled></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <div class="tbl-wrap">
        <b-table
          class="mb-0"
          ref="tblRequestItem"
          outlined
          striped
          hover
          small
          style="font-size: smaller"
          :items="requestItem.items"
          :fields="requestItem.fields"
          :current-page="requestItem.page"
          :per-page="requestItem.limit"
          @row-clicked="rowClicked"
          :key="requestItem.page"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(jasa)="data">
            <span v-if="data.item.jasa == 1">Service</span>
            <span v-else>Material</span>
          </template>
          <template v-slot:cell(spekdetail)="data">
            <pre>{{ data.item.spekdetail }}</pre>
          </template>
          <template v-slot:cell(quantity)="data"> {{ data.item.qtyPurchase }} {{ data.item.unitsize }} </template>
        </b-table>
        <b-form-row class="ml-1 mr-1">
          <b-col md="6">
            Showing
            {{ (requestItem.page - 1) * requestItem.limit + 1 }}
            to
            {{ requestItem.page * requestItem.limit }}
            of
            {{ requestItem.total }}
            entries
          </b-col>
          <b-col md="6">
            <b-pagination align="right" :total-rows="requestItem.total" :per-page="requestItem.limit" v-model="requestItem.page"></b-pagination>
          </b-col>
        </b-form-row>
      </div>
      <h4 class="mt-2">Candidat Vendor/Supplier</h4>

      <b-card no-body class="mt-2">
        <b-tabs card v-model="tabIndex">
          <b-tab v-for="(item, index) in requestItem.items" :key="index" :title="`${index + 1}. ${item.itemname}`">
            <b-table class="mb-0" :ref="`tblItem#${index}.`" outlined striped hover small style="font-size: smaller" :fields="fieldsCandidat" :items="candidats[index]">
              <template v-slot:cell(skore)="data">
                <span v-if="data.item.skore"> {{ data.item.skore }}. {{ data.item.NilaiRank | numFormat }}</span>
                <span v-else>{{ data.index + 1 }}</span>
              </template>
              <template v-slot:cell(selected)="data">
                <!-- <b-form-checkbox  v-model="data.item.terpilih" style="width:20px;" @change="changeTerpilih(data)" :disabled="(candidats[index].length==1)"></b-form-checkbox> -->
                <b-form-checkbox v-model="data.item.terpilih" style="width: 20px" :value="1" :unchecked-value="0" @change="changeTerpilih(index, data)"></b-form-checkbox>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <!--  input note best suplier -->
    <b-modal ref="modal" v-model="showNoteBestSup" size="md" title="" @ok="handleOk">
      <form ref="form" @submit.stop.prevent="handleOk">
        <b-form-group label="Note Best Suplier" label-for="name-input" invalid-feedback="Note is required">
          <b-form-textarea id="name-input" v-model="noteQutes" :state="noteQutesState != 'Invalid'" :rows="3" required></b-form-textarea>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>
<style lang="scss">
.tbl-wrap {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  min-height: 100px;
  border: 1px solid silver;
}
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 130px;
    }
  }
}
.form-group {
  margin-bottom: 2px;
  .input-group {
    padding-bottom: 0;
  }
}
.row-details-form {
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 80px;
    }
  }
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import moment from "moment";
import proctender from "../../apis/proctender";
import { validationMixin } from "vuelidate";
import { required, requiredIf, requiredUnless, minValue, maxLength, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading },
  mixins: [validationMixin],
  validations: {
    model: {
      nomor: { required },
      tanggal: { required },
      uraian: { required },
      requisition: { required },
    },
    vendorsObj: {
      requestno: { required },
    },
    noteQutes: { required },
  },
  data() {
    return {
      saveEnabled: true,
      tabIndex: 0,
      isLoading: false,
      showReport: false,
      showNoteBestSup: false,
      idTenderQuot: false, // ref untuk memasukan note
      reportUrl: null,
      model: { nomor: "", tanggal: "", uraian: "", requisition: "" },
      requestItem: {
        items: [],
        // {reqdtlkey:'reqdtlkey1', partnumber:'icode001',jasa:'0', itemname:'master item#1', description:'deskripsi item1'},
        //     {reqdtlkey:'reqdtlkey2', partnumber:'icode002',jasa:'0', itemname:'master item#2', description:'deskripsi item2'}
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "partnumber",
            label: "Master Item Code",
            thStyle: "width:100px",
            sortable: true,
          },
          {
            key: "itemname",
            label: "Master Item Name",
            thStyle: "width:240px",
            sortable: true,
          },
          {
            key: "jasa",
            label: "_",
            thStyle: "width:80px",
            sortable: true,
          },
          {
            key: "spekdetail",
            label: "Description",
            thStyle: "width:240px",
          },
          {
            key: "quantity",
            label: "Quantity",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
          },
        ],
        page: 1,
        limit: 6,
        total: 0,
      },
      itemSelected: {},
      fieldsCandidat: [
        { key: "skore", label: "Rank score", thStyle: "width:60px" },
        {
          key: "vendorinfo",
          label: "Supplier/Vendor",
          thStyle: "width:240px",
        },
        {
          key: "qtySupply",
          label: "Quantity Available",
          thStyle: "width:90px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "netprice",
          label: "Nett Price",
          thStyle: "width:110px",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "othercost",
          label: "Other Cost",
          thStyle: "width:110px",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "kenaPPN",
          label: "VAT",
          thStyle: "width:60px",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "LamaHari",
          label: "Delivery Days",
          thStyle: "width:110px",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "WarrantyTxt",
          label: "Waranty Periode",
          thStyle: "width:120px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "TermTxt",
          label: "Payment Term",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "Note",
          label: "Note/Remark",
          thStyle: "width:300px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "selected",
          label: "select",
          thStyle: "width:20px",
          sortable: true,
        },
      ],
      candidats: [],
      quotations: [],
      noteQutesState: null,
      noteQutes: "",
    };
  },
  // computed: {
  //     invalidNoteQuotes(){
  //        const valid = this.$refs.form.checkValidity()
  //         this.noteQutesState = valid ? 'valid' : 'invalid'
  //         return valid
  //     }
  //     invalidvendors() {
  //     //   this.vendors.kenappn= (this.vendors.ppn != 0);
  //       this.$v.vendorsObj.$touch();
  //       return this.$v.vendorsObj.$invalid;
  //     },
  //     invalidModel() {
  //       this.$v.model.$touch();
  //       return this.$v.model.$invalid;
  //     },
  // },
  watch: {
    tabIndex: function (newval) {
      let idx = newval + 1;
      this.requestItem.page = Math.ceil(idx / this.requestItem.limit);
      this.$forceUpdate();
      if (this.requestItem.items[newval]) {
        if (this.itemSelected && this.itemSelected._rowVariant) {
          delete this.itemSelected._rowVariant;
        }
        this.itemSelected = this.requestItem.items[newval];
        this.itemSelected._rowVariant = "info";
        this.$forceUpdate();
      }
    },
  },
  created: async function () {
    if (this.$route.params.idTender) {
      toastr.info("Loading Order Detail, please wait");
      try {
        this.isLoading = true;
        const data = await proctender.detailStep4(this.$route.params);
        this.isLoading = false;
        const row = data[0][0];
        // this.saveEnabled=(row.send2wf === 0);
        row.tanggal = row.tanggal ? moment(row.tanggal).format("YYYY-MM-DD") : "";
        for (var key in row) {
          this.model[key] = row[key];
        }
        this.requestItem.items = data[1];
        this.requestItem.total = this.requestItem.items.length;
        this.quotations = data[2];
        this.candidats = [];
        let skore;
        let rfq;
        this.requestItem.items.forEach((itemsmry, index) => {
          // console.log('-----------------')
          // console.log('this.requestItem.items',this.requestItem.items[index].terpilih)
          skore = 1;
          rfq = this.quotations.reduce((newArr, item) => {
            if (item.idTenderItem === itemsmry.idTenderItem) {
              item.skore = item.skore || skore;
              // item.terpilih = item.terpilih===1?true:false;
              newArr.push(item);
              skore += 1;
            }
            return newArr;
          }, []);
          // console.log(`rfq skored #${index} :`, rfq);
          this.candidats.push(rfq);
          // this.candidats = this.candidats.concat(rfq);
        });
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
      if (this.requestItem.items.length > 0) {
        this.itemSelected = this.requestItem.items[0];
        this.itemSelected._rowVariant = "info";
      }
    } else {
      router.push({ name: "procurement.tendering" });
    }
  },
  methods: {
    changeTerpilih(idxItem, data) {
      const idx = data.index;
      this.idxItem = idxItem;
      this.idxcandidat = idx;
      if (data.item.terpilih == 1) {
        this.noteQutes = data.item.Note;
        this.idTenderQuot = data.item.idTenderQuot;
        data.item.terpilih = 0;
        data.item.Note = "";
        this.showNote();
      }
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.noteQutesState = valid ? "valid" : "invalid";
      return valid;
    },
    rowClicked(record, index) {
      if (this.itemSelected && this.itemSelected._rowVariant) {
        delete this.itemSelected._rowVariant;
      }
      this.itemSelected = record;
      record._rowVariant = "info";

      let idx = (this.requestItem.page - 1) * this.requestItem.limit;

      this.tabIndex = idx + index;
      // this.candidat(index);
      this.$forceUpdate();
    },
    // candidat: function(idx) {
    //     const itemsmry = this.requestItem.items[idx];
    //     let skore=1;
    //     let rfq = this.vendors.items.reduce((newArr, item) => {
    //         if (item.idTenderItem === itemsmry.idTenderItem) {
    //             item.skore=skore;
    //             newArr.push(item);
    //             skore+=1;
    //         }
    //         return newArr;
    //     }, []);
    //     return rfq;
    // },
    backStep() {
      // update status=1 to PREVIOUS STEPS
      // hapus semua vendor/supplier yang pernah dipilih
      // router.push({name :`procurement.tenderingfrm${this.model.idstatus}`, params: { idTender: this.model.idTender}});
      router.push({ name: `procurement.tenderingfrm3`, params: { idTender: this.model.idTender } });
    },
    nextStep: async function () {
      const data = await proctender.detail(this.model);
      if (data[2].length > 0) {
        // update field status=3 to NEXT STEPS
        // router.push({name :`procurement.tenderingfrm${this.model.idstatus}`, params: { idTender: this.model.idTender}});
        router.push({ name: `procurement.tenderingfrm3`, params: { idTender: this.model.idTender } });
      } else {
        toastr.error("Please fill at least 1(one) Vendor/Supplier selected, then click Save", "ERROR MESSAGE");
      }
    },
    showNote: function () {
      this.showNoteBestSup = true;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      if (!this.checkFormValidity()) {
        return;
      }
      // console.log('this.noteQutes',this.noteQutes)
      this.handleSubmitNote();
    },
    handleSubmitNote: async function () {
      const arrCandidats = this.candidats[this.idxItem];
      const pilihan = arrCandidats[this.idxcandidat];
      pilihan.terpilih = 1;
      pilihan.Note = this.noteQutes;

      const idxB4 = arrCandidats.findIndex((c) => c.terpilih == 1 && c.idTenderQuot != pilihan.idTenderQuot);
      if (idxB4 > -1) {
        const pilihanB4 = arrCandidats[idxB4];
        pilihanB4.terpilih = 0;
        const quotIdx = this.quotations.findIndex((x) => x.idTenderQuot === pilihanB4.idTenderQuot);
        if (quotIdx > -1) {
          this.quotations[quotIdx].Note = "";
          this.quotations[quotIdx].terpilih = 0;
        }
      }

      let findIdx = this.quotations.findIndex((x) => x.idTenderQuot === this.idTenderQuot);
      this.quotations[findIdx].Note = this.noteQutes;
      this.quotations[findIdx].terpilih = 1;
      this.$nextTick(() => {
        this.noteQutes;
        this.$refs.modal.hide();
      });
    },
    save: async function () {
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.isLoading = true;
          const terpilih = this.quotations.reduce((newArr, item) => {
            if (item.terpilih == 1) {
              newArr.push(item);
            }
            return newArr;
          }, []);

          if (terpilih.length > 0) {
            await proctender.saveStep4of4({ idTender: this.model.idTender, terpilih });
            toastr.success("Saved successfully", "Selected Vendor/supplier");
          } else {
            toastr.error("Please fill at least 1(one) Supplier/vendor", "ERROR MESSAGE");
          }
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          toastr.error(JSON.stringify(error), "Save Order Error");
        }
      }
    },
    onSelectLkuVendor: async function (_selected) {
      this.model.vendorinfo = _selected.vendor_name.trim() + " | " + _selected.vendor_code.trim();
      _selected.selected = true;
      this.vendors.items.push(_selected);
      this.lkuVendorShow = false;
    },
    printBestSupplier: async function () {
      if (this.model && this.model.idTender) {
        this.isLoading = true;
        try {
          this.reportUrl = null; this.showReport = true;
          this.reportUrl = await proctender.printBestSupplier({ idTender: this.model.idTender });
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    close() {
      //   if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.tenderingfrm4')) {
      //     router.push({name:this.$store.state.prevRoute.name});
      //   } else {
      router.push({ name: "procurement.tendering" });
      //   }
    },
  },
};
</script>
